export default __webpack_public_path__ + "783904080aa6897ff706125039d1995a.png";